/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1sKx9ffix1qWmdscEUQHh6
// Component: D_brxtFheM3F
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import PageLayout from "../../PageLayout"; // plasmic-import: CF9w0NRrnxvp/component
import SectionHero from "../../SectionHero"; // plasmic-import: LAgK4hEGm2TV/component
import TopNav from "../../TopNav"; // plasmic-import: MzgISFkf8fEm/component
import ButtonPage from "../../ButtonPage"; // plasmic-import: voJV0X1zqcH0/component
import HeroUnerline from "../../HeroUnerline"; // plasmic-import: pfVxagK4NBto/component
import SectionFooter from "../../SectionFooter"; // plasmic-import: NAltgsviawN1/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1sKx9ffix1qWmdscEUQHh6/projectcss
import sty from "./PlasmicTheIndependent.module.css"; // plasmic-import: D_brxtFheM3F/css

createPlasmicElementProxy;

export const PlasmicTheIndependent__VariantProps = new Array();

export const PlasmicTheIndependent__ArgProps = new Array("onClick2");

const $$ = {};

function PlasmicTheIndependent__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const globalVariants = _useGlobalVariants();
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"pageHome"}
          data-plasmic-override={overrides.pageHome}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            styleTokensClassNames,
            sty.pageHome
          )}
        >
          <PageLayout
            data-plasmic-name={"pageLayout"}
            data-plasmic-override={overrides.pageLayout}
            className={classNames("__wab_instance", sty.pageLayout)}
            content={
              <React.Fragment>
                <SectionHero
                  data-plasmic-name={"sectionHero"}
                  data-plasmic-override={overrides.sectionHero}
                  className={classNames("__wab_instance", sty.sectionHero)}
                  colWidth={"medium"}
                  navbar={
                    <TopNav
                      data-plasmic-name={"topNav"}
                      data-plasmic-override={overrides.topNav}
                      className={classNames("__wab_instance", sty.topNav)}
                      pageButtons={
                        <React.Fragment>
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ave9H
                            )}
                          >
                            {"["}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__qkis7
                            )}
                            content={"overview"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOverview"] = true
                                ? (() => {
                                    const actionArgs = { destination: `/` };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOverview"] != null &&
                                typeof $steps["goToPartnerOverview"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOverview"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOverview"] =
                                  await $steps["goToPartnerOverview"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__ovVgg
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__xKsvi
                            )}
                            content={"mission"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerMission"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/mission`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerMission"] != null &&
                                typeof $steps["goToPartnerMission"] ===
                                  "object" &&
                                typeof $steps["goToPartnerMission"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerMission"] =
                                  await $steps["goToPartnerMission"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__tjj53
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__lKxtY
                            )}
                            content={"the independent"}
                            isSelected={true}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToPartnerOpenCall"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/the-independent`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToPartnerOpenCall"] != null &&
                                typeof $steps["goToPartnerOpenCall"] ===
                                  "object" &&
                                typeof $steps["goToPartnerOpenCall"].then ===
                                  "function"
                              ) {
                                $steps["goToPartnerOpenCall"] =
                                  await $steps["goToPartnerOpenCall"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__lm8Xz
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage___5UrBz
                            )}
                            content={"early bird"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToEarlyBird"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: `/early-bird`
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToEarlyBird"] != null &&
                                typeof $steps["goToEarlyBird"] === "object" &&
                                typeof $steps["goToEarlyBird"].then ===
                                  "function"
                              ) {
                                $steps["goToEarlyBird"] =
                                  await $steps["goToEarlyBird"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__fMgsH
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__rkL74
                            )}
                            content={"contact"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComSupport"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination: "https://o21p.com/support"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComSupport"] != null &&
                                typeof $steps["goToHttpsO21PComSupport"] ===
                                  "object" &&
                                typeof $steps["goToHttpsO21PComSupport"]
                                  .then === "function"
                              ) {
                                $steps["goToHttpsO21PComSupport"] =
                                  await $steps["goToHttpsO21PComSupport"];
                              }
                            }}
                            textColor={"tertiary"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__szk2U
                            )}
                          >
                            {"|"}
                          </div>
                          <ButtonPage
                            className={classNames(
                              "__wab_instance",
                              sty.buttonPage__oygKv
                            )}
                            content={"join the community"}
                            onClick={async () => {
                              const $steps = {};
                              $steps["goToHttpsO21PComPartnersCommunity"] = true
                                ? (() => {
                                    const actionArgs = {
                                      destination:
                                        "https://o21p.com/partners-community"
                                    };
                                    return (({ destination }) => {
                                      if (
                                        typeof destination === "string" &&
                                        destination.startsWith("#")
                                      ) {
                                        document
                                          .getElementById(destination.substr(1))
                                          .scrollIntoView({
                                            behavior: "smooth"
                                          });
                                      } else {
                                        location.assign(destination);
                                      }
                                    })?.apply(null, [actionArgs]);
                                  })()
                                : undefined;
                              if (
                                $steps["goToHttpsO21PComPartnersCommunity"] !=
                                  null &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ] === "object" &&
                                typeof $steps[
                                  "goToHttpsO21PComPartnersCommunity"
                                ].then === "function"
                              ) {
                                $steps["goToHttpsO21PComPartnersCommunity"] =
                                  await $steps[
                                    "goToHttpsO21PComPartnersCommunity"
                                  ];
                              }
                            }}
                            textColor={"brand"}
                          />

                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__dXai9
                            )}
                          >
                            {"]"}
                          </div>
                        </React.Fragment>
                      }
                    />
                  }
                  sectionId={"top"}
                  showTagline={false}
                  slot={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__nqokc
                      )}
                    >
                      {"Dentistry doesn't burn you out. Everything else does."}
                    </div>
                  }
                >
                  <h1
                    data-plasmic-name={"h1"}
                    data-plasmic-override={overrides.h1}
                    className={classNames(
                      projectcss.all,
                      projectcss.h1,
                      projectcss.__wab_text,
                      sty.h1
                    )}
                  >
                    {"the independent."}
                  </h1>
                </SectionHero>
                <section
                  data-plasmic-name={"s1"}
                  data-plasmic-override={overrides.s1}
                  className={classNames(projectcss.all, sty.s1)}
                >
                  <div
                    data-plasmic-name={"container"}
                    data-plasmic-override={overrides.container}
                    className={classNames(projectcss.all, sty.container)}
                  >
                    <div
                      data-plasmic-name={"wrapperDiv"}
                      data-plasmic-override={overrides.wrapperDiv}
                      className={classNames(projectcss.all, sty.wrapperDiv)}
                    >
                      <HeroUnerline
                        data-plasmic-name={"heroUnerline"}
                        data-plasmic-override={overrides.heroUnerline}
                        className={classNames(
                          "__wab_instance",
                          sty.heroUnerline
                        )}
                      />

                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__i08Ht
                        )}
                      >
                        {
                          "Independence is an operating stance. A person choosing authorship over permission, local judgment over centralized templates, and responsibility over anonymity. The independent is the one who carries the cost of decisions and therefore insists on the right to decide."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__ncTxe
                        )}
                      >
                        {
                          "The independent is the individual who views their work as a form of self-expression. They\u2019ve stepped beyond the pure operator role and created what we call a \u201cpersonal system\u201d around their work. A vehicle through which they contribute to the economy: a small business, a practice, an agency, a studio, or something in between that doesn\u2019t even have a name yet."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__yGu5J
                        )}
                      >
                        {
                          "They value autonomy more than comfort. They care about how something is done as much as what is done. They push at the edges of what\u2019s possible in their field. They experiment with tools, workflows, and models that give them more leverage without giving up who they are."
                        }
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__fmDy
                        )}
                      >
                        {"We work with and build for these people. "}
                      </p>
                      <p
                        className={classNames(
                          projectcss.all,
                          projectcss.p,
                          projectcss.__wab_text,
                          sty.p__emM2
                        )}
                      >
                        {"We share the same stance."}
                      </p>
                    </div>
                  </div>
                </section>
                <SectionFooter
                  data-plasmic-name={"sectionFooter"}
                  data-plasmic-override={overrides.sectionFooter}
                  className={classNames("__wab_instance", sty.sectionFooter)}
                  layout={"withOffset"}
                  sectionId={"footer"}
                />
              </React.Fragment>
            }
            layoutSections={"withNav"}
          />

          {(hasVariant(globalVariants, "screen", "tablet") ? true : false) ? (
            <div
              data-plasmic-name={"noBudgetSmallScreens"}
              data-plasmic-override={overrides.noBudgetSmallScreens}
              className={classNames(projectcss.all, sty.noBudgetSmallScreens)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cWCaM
                )}
              >
                {"o21p"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wh56E
                )}
              >
                {
                  "our massive development budget is dedicated to designing and building the platform for larger screens."
                }
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__xnt3U
                )}
              >
                {"\u2013 at least 900px wide \u2013"}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageHome: [
    "pageHome",
    "pageLayout",
    "sectionHero",
    "topNav",
    "h1",
    "s1",
    "container",
    "wrapperDiv",
    "heroUnerline",
    "sectionFooter",
    "noBudgetSmallScreens"
  ],

  pageLayout: [
    "pageLayout",
    "sectionHero",
    "topNav",
    "h1",
    "s1",
    "container",
    "wrapperDiv",
    "heroUnerline",
    "sectionFooter"
  ],

  sectionHero: ["sectionHero", "topNav", "h1"],
  topNav: ["topNav"],
  h1: ["h1"],
  s1: ["s1", "container", "wrapperDiv", "heroUnerline"],
  container: ["container", "wrapperDiv", "heroUnerline"],
  wrapperDiv: ["wrapperDiv", "heroUnerline"],
  heroUnerline: ["heroUnerline"],
  sectionFooter: ["sectionFooter"],
  noBudgetSmallScreens: ["noBudgetSmallScreens"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTheIndependent__ArgProps,
          internalVariantPropNames: PlasmicTheIndependent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTheIndependent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageHome") {
    func.displayName = "PlasmicTheIndependent";
  } else {
    func.displayName = `PlasmicTheIndependent.${nodeName}`;
  }
  return func;
}

export const PlasmicTheIndependent = Object.assign(
  // Top-level PlasmicTheIndependent renders the root element
  makeNodeComponent("pageHome"),
  {
    // Helper components rendering sub-elements
    pageLayout: makeNodeComponent("pageLayout"),
    sectionHero: makeNodeComponent("sectionHero"),
    topNav: makeNodeComponent("topNav"),
    h1: makeNodeComponent("h1"),
    s1: makeNodeComponent("s1"),
    container: makeNodeComponent("container"),
    wrapperDiv: makeNodeComponent("wrapperDiv"),
    heroUnerline: makeNodeComponent("heroUnerline"),
    sectionFooter: makeNodeComponent("sectionFooter"),
    noBudgetSmallScreens: makeNodeComponent("noBudgetSmallScreens"),
    // Metadata about props expected for PlasmicTheIndependent
    internalVariantProps: PlasmicTheIndependent__VariantProps,
    internalArgProps: PlasmicTheIndependent__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "the independent.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicTheIndependent;
/* prettier-ignore-end */
